import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Typography, mediaQuery } from '@lacedltd/laced-components'

export const PageContainer = styled.section<{ wide: boolean }>(({ wide }) => ({
  width: '100%',
  maxWidth: wide ? '55rem' : tokens.breakpoints.m,
  padding: `${tokens.spacing[9]} 0 0`,
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',

  [mediaQuery.m.min]: {
    padding: `${tokens.spacing[12]} ${tokens.spacing[8]}`
  }
}))

export const Breadcrumb = styled.a({
  fontSize: tokens.fontSize[1],
  color: tokens.color.airJordan[600],
  display: 'flex',
  alignItems: 'center',
  padding: `0 ${tokens.spacing[6]}`,

  img: {
    transform: 'rotate(-90deg)',
    width: tokens.spacing[3],
    marginRight: tokens.spacing[2]
  },

  '&:hover': {
    color: tokens.color.airJordan[800]
  },

  [mediaQuery.m.min]: {
    padding: 0
  }
})

export const PageHeader = styled.header({
  display: 'flex',
  flexDirection: 'column',
  padding: `0 ${tokens.spacing[6]}`,

  p: {
    margin: `${tokens.spacing[5]} 0 0`
  },

  [mediaQuery.m.min]: {
    padding: 0
  }
})

export const PageTitle = styled(Typography.Heading)({
  margin: `${tokens.spacing[6]} 0 0`
})

export const ChildrenContainer = styled.div({
  display: 'flex',
  marginTop: tokens.spacing[6],
  flexDirection: 'column'
})
